const GoogleConfiguration = {
  apiKey: 'AIzaSyBQpXBnX4UCZJOm0TBdQ1HvNBLY7qXehUI',
};

export default GoogleConfiguration;
